import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

const realYieldFormatter = new Intl.NumberFormat("cs-CZ", {
	style: "percent",
	maximumFractionDigits: 1,
});

export const formatGoalRealYield = (rate: number = GOAL_REAL_YIELD): string =>
	realYieldFormatter.format(rate);
